import { ajax } from 'utils';
// @ts-ignore
import _ from 'lodash';
import { QueryField } from 'modules/types/commons/Query';
import { WorkBenchMenuKey } from '../types/workbench';
import * as api from 'services/javaApi';

export const LOADING = 'mpc/external/workbench/list_loading';
export const GET_LIST_SUCCESS = 'mpc/external/workbench/get_list_success';
export const GET_LIST_OPTIONS_SUCCESS = 'mpc/external/workbench/get_list_options_success';
export const CHANGE_CONDITIONS = 'mpc/external/workbench/change_conditions';
export const CHANGE_CHECK = 'mpc/external/workbench/change_check';
export const CHANGE_LIST_FINISH_TYPE = 'mpc/external/workbench/change_list_finish_type';

export interface GetListSuccess extends WorkBenchMenuKey {
  type: typeof GET_LIST_SUCCESS;
  data?: any;
}

export interface GetListOptionsSuccess extends WorkBenchMenuKey {
  type: typeof GET_LIST_OPTIONS_SUCCESS;
  data?: QueryField[];
}

export interface ChangeConditions extends WorkBenchMenuKey {
  type: typeof CHANGE_CONDITIONS;
  data?: any;
}

export interface Loading extends WorkBenchMenuKey {
  type: typeof LOADING;
}

export interface ChangeCheck extends WorkBenchMenuKey {
  type: typeof CHANGE_CHECK;
  data?: any;
}

export interface ChangeListFinishType extends WorkBenchMenuKey {
  type: typeof CHANGE_LIST_FINISH_TYPE;
  data?: any;
}

export type WorkbenchActions =
  | GetListSuccess
  | Loading
  | GetListOptionsSuccess
  | ChangeConditions
  | ChangeCheck
  | ChangeListFinishType;

export function changeCheck(menuKey: string, data: any) {
  return {
    type: CHANGE_CHECK,
    data: { menuKey, data },
    menuKey,
  };
}

export function changeConditions(conditions: any = {}) {
  return {
    type: CHANGE_CONDITIONS,
    data: conditions,
  };
}

export function getList(menuKey: string, conditions: any = {}, pagination = {}) {
  return {
    types: [LOADING, GET_LIST_SUCCESS, null],
    promise: () => ajax({
      url: `outsource/sm/my_workbenches/${_.snakeCase(menuKey)}`,
      method: 'POST',
      body: { conditions, ...pagination },
    }).then((res: any) => {
      return { data: { list: res.data, conditions, menuKey } };
    }),
    menuKey,
  };
}

export function getFilterOptions(menuKey: string, keys: string[]) {
  return {
    types: [null, GET_LIST_OPTIONS_SUCCESS, null],
    promise: () => api.outsourceCommonFilterOptions({
      keys,
      state: menuKey,
    }),
    menuKey,
  };
}

export function changeListFinishType(data: any) {
  return {
    type: CHANGE_LIST_FINISH_TYPE,
    data,
  };
}
